import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const NewBrunswickIcon = (props: BaseProvinceIconProps) => {
  return (
    <path
      id="NB"
      {...props}
      d="M298.6,224.5c0.3,0,0.5,0.1,0.8,0.2c1.2,0.5,2.2,1.5,3.2,2.2c1.1,0.8,2.2,1.6,3.2,2.4h0.3l3.6-4.3
        c0.2-0.2,0.4-0.3,0.7-0.3c0.2,0,0.4,0.1,0.6,0.2c0.4,0.4,0.3,1.5,0.2,2c-0.1,0.7-0.4,1.4-0.5,2.1c-0.2,0.8-0.3,1.6-0.5,2.4
        c-0.1,0.3,0.1,0.6,0.3,0.9c0.5,0.4,1.2,0.7,1.6,1.2c0.4,0.6,0.3,1.4,0.7,2.1c0.5,0.7,1.2,1.2,1.9,1.8l1.9,1.8
        c0.3,0.3,0.7,0.4,1.1,0.4c0.8,0,1.8-0.3,2.4-0.4h0.1c0.8,0,1.4,0.9,1,1.6l-1.4,2.6l-0.1,0.1c-0.4,0.6-0.9,1.3-1.3,1.9
        c-1.2,1.8-2.4,3.5-3.6,5.3c-0.5,0.7-1,1.5-1.5,2.1c-1,1.1-6.4,3.8-8.1,4.1c-0.1,0-0.1,0-0.2,0c-0.5,0-0.8-0.4-1.3-0.7
        c-0.5-0.4-2.6-2.1-3.1-2.5c-0.6-0.5-5.1-10.9-5.3-11.5c-0.5-1.1-1.3-1-2.4-1.1c-0.4,0-0.8-0.1-1.2-0.1c-0.6,0-1.2,0.1-1.7,0.3
        c-0.8,0.3-1.4,1.1-2.3,1.1c-0.7,0-1.1-0.6-1-1.2c0.1-0.6,0.5-1,0.8-1.4c0.5-0.7,8.9-13.1,9.4-13.9c0.3-0.5,0.7-1.1,1.3-1.2
        C298.4,224.5,298.5,224.5,298.6,224.5z"
    />
  );
};
